import { FC } from "react";
import styles from "./styles.scss";

interface StaffNameErrorProps {
  touched: boolean | undefined;
  error: string | undefined;
}

export const StaffNameError: FC<StaffNameErrorProps> = ({ touched, error }) => {
  if (shouldDisplayError(touched, error)) {
    return <p className={styles.staffName__error}>{error}</p>;
  }
  return null;
};

interface CommentErrorProps {
  touched: boolean | undefined;
  error: string | undefined;
}

export const CommentError: FC<CommentErrorProps> = ({ touched, error }) => {
  if (shouldDisplayError(touched, error)) {
    return <p className={styles.comment__error}>{error}</p>;
  }
  return null;
};

const shouldDisplayError = (
  touched: boolean | undefined,
  error: string | undefined,
): boolean => {
  return Boolean(touched) && Boolean(error);
};
